var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#CB6CE6",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M44.988 13.984a1 1 0 0 0-.695.309L25 33.586 5.707 14.293a1 1 0 0 0-.715-.305c-.41.004-.773.25-.93.625a1 1 0 0 0 .231 1.094l20 20a1 1 0 0 0 1.414 0l20-20c.297-.285.387-.727.23-1.105a1.01 1.01 0 0 0-.949-.618"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.299fbafb5eb524888cc9a1461a3252f9.svg";
export { ForwardRef as ReactComponent };